import getConfig from "next/config"

const config = getConfig()

interface EnvVars {
    ENVIRONMENT: string
    GRAPHQL_SERVER_URL: string
    ACCOUNT_ASSETS_URL: string
    COGNITO_IDENTITY_POOL_ID: string
    COGNITO_USER_POOL_ID: string
    COGNITO_CLIENT_ID: string
    GOOGLE_API_KEY: string
    GOOGLE_OAUTH_CLIENT_ID: string
    FACEBOOK_LOGIN_APP_ID: string
    SENTRY_RELEASE: string
    HOTJAR_ID: string
    GOOGLE_ANALYTICS_ID: string
    NODE_ENV: string
}

export const envVars: EnvVars = config ? config.publicRuntimeConfig.process.env : {}
